import React, { useEffect, useContext, useState } from "react";
import * as Storage from "ts-storage";
import { base_url } from "../..";
import { FoodContext } from "./../../API/FoodContext";
import { AuthContext } from "../../API/AuthContext";
import FlashMessage from "../UI/FlashMessage";
import { postOrderedFood, createNewOrder } from "../../API/OrderAPI";
import Loading, { FoodLoading } from "../UI/Loading";

const FoodCart: React.FC<{
  thumbnail: string;
  name: string;
  price: number;
  quantity: number;
  addQuantity: any;
  removeQuantity: any;
  removeFromCart: any;
}> = ({
  thumbnail,
  name,
  price,
  quantity,
  addQuantity,
  removeQuantity,
  removeFromCart,
}) => {
  return (
    <div className="food-on-cart my-3">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <div className="cart-img-wrapper m-0">
            <img
              src={`${base_url}${thumbnail}`}
              className="img-fluid "
              alt=""
            />
          </div>
          <h6 className="font-weight-bold m-0">{name}</h6>
        </div>
        <p className=" m-0 ">Qty {quantity}</p>
        <p className="h5 m-0 font-weight-bold">${price * quantity}</p>

        <div className="m-0 text-center">
          <div className="d-flex">
            <button className="btn btn-sm" onClick={removeQuantity}>
              -
            </button>
            <button
              className="btn btn-sm btn-primary rounded mr-2"
              onClick={addQuantity}
            >
              +
            </button>
            <button className="btn btn-sm  mr-2" onClick={removeFromCart}>
              <i className="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const FoodCartListing: React.FC<{
  foods: any;
  addQuantity: (id: string) => void;
  removeQuantity: (id: string) => void;
  removeFromCart: (id: string) => void;
}> = ({ foods, addQuantity, removeQuantity, removeFromCart }) => {
  return (
    <ul className="food-cart-listing">
      <li className="">
        {foods.length === 0 ? (
          <div className="text-center">No Food Added</div>
        ) : (
          foods.map((food: any) => {
            return (
              <FoodCart
                removeFromCart={() => removeFromCart(food.id)}
                key={food.id}
                thumbnail={food.thumbnail.url}
                name={food.name}
                price={food.price}
                quantity={food.quantity}
                addQuantity={() => addQuantity(food.id)}
                removeQuantity={() => removeQuantity(food.id)}
              />
            );
          })
        )}
      </li>
    </ul>
  );
};

export default function FoodCartContainer() {
  const [isAuth, , currentUser, , , setFlashMessage] = useContext(AuthContext);

  const [, , , , showCart, setShowCart, cart, setCart] = useContext(
    FoodContext
  );
  const [totalPrice, setTotalPrice] = useState<number>(0);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [successLoading, setSuccessLoading] = useState<boolean>(false);

  useEffect(() => {
    // load cart from localstorage
    let total = 0;
    cart.forEach((food: any) => {
      console.log(food.price);
      total += food.price * food.quantity;
    });

    setTotalPrice(total);
  }, [cart]);

  function removeQuantity(id: string) {
    let updatedFood = cart.map((food: any) => {
      if (food.id === id && food.quantity > 1) {
        food.quantity -= 1;
      }
      return food;
    });

    setCart(updatedFood);
    Storage.set("foodcart", JSON.stringify(updatedFood));
  }

  function addQuantity(id: string) {
    let updatedFood = cart.map((food: any) => {
      if (food.id === id) {
        food.quantity += 1;
      }
      return food;
    });

    setCart(updatedFood);
    Storage.set("foodcart", JSON.stringify(updatedFood));
  }

  function closeCart() {
    setShowCart(false);
    if (successLoading) Storage.set("foodcart", JSON.stringify([]));
  }

  function removeFromCart(id: string) {
    let filteredFood = cart.filter((food: any) => food.id !== id);
    setCart(filteredFood);
    Storage.set("foodcart", JSON.stringify(filteredFood));
  }

  async function checkoutClickHandler() {
    setIsLoading(true);
    if (isAuth && currentUser) {
      if (cart.length === 0) {
        setFlashMessage({
          type: "danger",
          show: true,
          msg: "Please pick a food",
        });
        setIsLoading(false);
      } else {
        // send to api ordered_food
        console.log(currentUser.user_info);
        let orderedfoods = cart.map((food: any) => {
          return {
            quantity: food.quantity,
            food: food.id,
          };
        });
        //
        try {
          const res: any = await postOrderedFood(orderedfoods);
          console.log(res);

          let orderedFoodIds = res.map((orderfood: any) => orderfood.id);

          let order = {
            address: currentUser.user_info.address,
            total_price: totalPrice,
            status: 0,
            orderedfoods: orderedFoodIds,
            user: currentUser.id,
          };

          const orderres = await createNewOrder(order);
          console.log(orderres);

          if (orderres) {
            setIsLoading(false);
            setSuccessLoading(true);
          }
          Storage.set("foodcart", JSON.stringify([]));
        } catch (e) {
          console.log(e);
          setFlashMessage({
            type: "danger",
            show: true,
            msg: "Order is failed to proceed, Please Try Again",
          });
        }
      }
    } else {
      setFlashMessage({
        type: "danger",
        show: true,
        msg: "Please login to checkout your order",
      });
      setIsLoading(false);
    }
  }

  return (
    <div className={`food-cart ${showCart ? "show" : ""}`}>
      <button className="btn float-right mt-n5 mr-4" onClick={closeCart}>
        X
      </button>
      <FlashMessage />
      {isLoading ? (
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <Loading />
            </div>
          </div>
        </div>
      ) : successLoading ? (
        <div className="container">
          <div className="row">
            <div
              className="col-md-12 d-flex justify-content-center align-items-center"
              style={{ height: "400px" }}
            >
              <div>
                <FoodLoading />
                <p
                  className="font-weight-bold text-center h5"
                  style={{ lineHeight: 1.8 }}
                >
                  Your Order has been successfully placed. Please wait for the
                  food coming :D
                </p>
                <p className="mt-5 text-center">Thank you for your order</p>
                <button className="btn btn-info btn-block" onClick={closeCart}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3>Your Cart</h3>
              <p>Finish your order right now :D</p>
            </div>
          </div>
          <FoodCartListing
            removeFromCart={removeFromCart}
            addQuantity={addQuantity}
            removeQuantity={removeQuantity}
            foods={cart}
          />
          <div className="row">
            <div className="col-md-12">
              <h3>
                Total Price:
                <span className="float-right mr-3">${totalPrice}</span>
              </h3>
            </div>
          </div>

          <button
            className="mt-5 btn btn-block btn-primary"
            onClick={checkoutClickHandler}
          >
            Checkout
          </button>

          <button className="mt-2 btn btn-block btn-info" onClick={closeCart}>
            Go to Menu
          </button>
        </div>
      )}
    </div>
  );
}
